<template>
  <div>
    <b-modal
      id="modal-input-pelanggaran"
      size="lg"
      centered
      :title="$store.state.modal.tambahDataPelanggaran"
      header-bg-variant="primary"
      header-text-variant="light"
    >
      <b-form>
        <b-form-group :label="$store.state.form.tanggal" label-cols-md="3">
          <DatePicker
            style="width: 100%"
            :state="checkIfValid('tanggalPelanggaran')"
            v-model="$v.dataPelanggaran.tanggalPelanggaran.$model"
          ></DatePicker>
        </b-form-group>

        <b-form-group :label="$store.state.form.jenisPelanggaran" label-cols-md="3">
          <Multiselect
            :state="checkIfValid('masterPelanggaranId')"
            v-model="$v.dataPelanggaran.masterPelanggaranId.$model"
            :options="pelanggaran"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            label="namaPelanggaran"
            placeholder="-- Pilih --"
          ></Multiselect>
        </b-form-group>

        <b-form-group :label="$store.state.form.sumberPelanggaran" label-cols-md="3">
          <b-form-select
            :options="sumber"
            :state="checkIfValid('jenisSumberPelanggaran')"
            v-model="$v.dataPelanggaran.jenisSumberPelanggaran.$model"
          ></b-form-select>
        </b-form-group>

        <b-form-group :label="$store.state.form.keteranganPelanggaran" label-cols-md="3">
          <b-form-input
            type="text"
            :state="checkIfValid('keteranganPelanggaran')"
            v-model="$v.dataPelanggaran.keteranganPelanggaran.$model"
          ></b-form-input>
        </b-form-group>
      </b-form>
      <template #modal-footer>
        <b-button
          variant="secondary"
          @click="$bvModal.hide('modal-input-pelanggaran')"
        >
          {{ $store.state.form.batal }}
        </b-button>
        <b-button
          variant="primary"
          :disabled="busy || !isValid"
          @click="simpan()"
        >
          {{ button }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
export default {
  name: "modalInput",
  props: ["data", "pelanggaran"],
  data() {
    return {
      dataPelanggaran: {
        masterPelanggaranId: "",
        jenisSumberPelanggaran: "",
        tanggalPelanggaran: "",
        keteranganPelanggaran: "",
      },
      sumber: [
        { value: "Internal", text: "Internal" },
        { value: "Eksternal", text: "Eksternal" },
      ],
      busy: false,
      button: "Simpan",
    };
  },
  computed: {
    formString() {
      return JSON.stringify(this.dataPelanggaran, null, 4);
    },
    isValid() {
      return !this.$v.dataPelanggaran.$invalid;
    },
    isDirty() {
      return this.$v.dataPelanggaran.$anyDirty;
    },
  },
  mixins: [validationMixin],
  validations: {
    dataPelanggaran: {
      tanggalPelanggaran: {
        required,
      },
      jenisSumberPelanggaran: {
        required,
      },
      keteranganPelanggaran: {
        required,
      },
      masterPelanggaranId: {
        required,
      },
    },
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v.dataPelanggaran[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    simpan() {
      let vm = this;
      // console.log(vm.data, "ini data simpan");
      // console.log(vm.dataPelanggaran, "ini data pelanggaran");
      if (vm.isValid) {
        vm.dataPelanggaran.masterPelanggaranId = vm.dataPelanggaran.masterPelanggaranId.id;
        vm.dataPelanggaran.dataKaryawanId = vm.data.dataKaryawanId;
        vm.dataPelanggaran.tanggalPelanggaran = vm.$moment(vm.dataPelanggaran.tanggalPelanggaran);
        vm.busy = true;
        vm.button = "Mohon Tunggu";
        vm.$axios
          .post("poolPelanggaran/register", vm.dataPelanggaran)
          .then((res) => {
            if (res.data.message == "sukses") {
              vm.button = "Simpan";
              vm.busy = false;
              vm.$emit("alertFromChild", {
                variant: "success",
                msg: "BERHASIL MENDAFTARKAN DATA PELANGGARAN",
                showing: true,
              });
              vm.dataPelanggaran.masterPelanggaranId = "";
              vm.dataPelanggaran.tanggalPelanggaran = "";
              vm.dataPelanggaran.jenisSumberPelanggaran = "";
              vm.dataPelanggaran.keteranganPelanggaran = "";
              vm.$v.$reset();
              vm.$bvModal.hide("modal-input-pelanggaran");
            } else {
              vm.button = "Simpan";
              vm.busy = false;
              vm.$emit("alertFromChild", {
                variant: "danger",
                msg: res.data.message.toUpperCase(),
                showing: true,
              });
            }
          })
          .catch((err) => {
            vm.button = "Simpan";
            vm.busy = false;
            vm.$emit("alertFromChild", {
              variant: "danger",
              msg: err.message.toUpperCase(),
              showing: true,
            });
          });
      }
    },
  },
};
</script>
